import React from 'react';
import { Typography, Box, Grid } from '@mui/material';
import TravelAgentImage from '../../assets/images/TravelAgent.png';
import DriverImage from '../../assets/images/Drivers.png';
import HotelStaffImage from '../../assets/images/HotelStaff.png';

const cardData = [
  {
    image: TravelAgentImage,
    title: 'Travel Agents',
    description: 'Add excursion income to your existing bookings',
  },
  {
    image: DriverImage,
    title: 'Drivers / Locals',
    description: 'Earn from tourists you already meet every day',
  },
  {
    image: HotelStaffImage,
    title: 'Hotel Staff / Promoters',
    description: 'Recommend excursions, track earnings, get paid fast',
  },
];

const WhoShdJoin = () => (
  <Box width="100%" py={5} px={{ xs: 2, sm: 4, md: 8, lg: 15 }}>
    <Box textAlign="center" mb={6}>
      <Typography
        fontFamily="Lato"
        fontWeight={900}
        variant="h4"
        gutterBottom
      >
        Who Should Join?
      </Typography>
      <Typography
        fontFamily="Lato"
        fontWeight={400}
        fontSize={{ xs: '14px', md: '16px' }}
        lineHeight="150%"
        letterSpacing="0.5px"
        maxWidth="800px"
        mx="auto"
        px={{ xs: 1, sm: 2 }}
      >
        Whether you’re in the tourism industry or just love connecting with travelers,
        the CanAm Affiliate Program is built for YOU. Here’s who’s earning — and how you can too:
      </Typography>
    </Box>

    <Grid container spacing={4} justifyContent="center">
      {cardData.map((card, index) => (
        <Grid item xs={12} sm={6} md={4} key={index}>
          <Box textAlign="center">
            <Box
              component="img"
              src={card.image}
              alt={card.title}
              sx={{
                width: '100%',
                height: { xs: '210px', sm: '230px' },
                objectFit: 'cover',
                borderRadius: 5,
                mb: 2,
              }}
            />
            <Typography
              fontWeight={700}
              fontFamily="Lato"
              variant="h6"
              gutterBottom
            >
              {card.title}
            </Typography>
            <Typography
              fontFamily="Lato"
              fontSize="14px"
              color="textSecondary"
              px={{ xs: 2, md: 5 }}
            >
              {card.description}
            </Typography>
          </Box>
        </Grid>
      ))}
    </Grid>
  </Box>
);

export default WhoShdJoin;
